import React, { useState } from 'react';
import SessionContext from '../contexts/SessionContext';

const SessionProvider = ({ children }) => {
  const [claims, setClaims] = useState({
    authenticationErrors: '',
    authenticationSource: '',
    exp: '',
    socialIssuer: '',
    roles: []
  });

  return (
    <SessionContext.Provider
      value={{
        authenticationErrors: claims.authenticationErrors || '',
        authenticationMethod: claims.authenticationSource,
        expiresOn: claims.exp,
        socialIssuer: claims.socialIssuer || '',
        roles: claims.roles || [],
        setClaims
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};

export default SessionProvider;
